import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import TeamIcon from "@components/icons/TeamIcon";
import { EventContext, LookupContext } from "@gp/components";
import { EventKeyBettingOffer } from "@gp/models";
import { EventKeyOffer } from "@gp/offer";
import { toDisplayOdd } from "@gp/utility";
import { observer } from "mobx-react";

import { OutrightOfferRowOfferButton } from "./OutrightOfferRowOfferButton";

export const OutrightOfferRowOffer = observer(
	function OutrightOfferRowOffer(props: {
		tip: EventKeyBettingOffer;
		eventKey: EventKeyOffer;
		countryCode?: string;
	}) {
		const { tip } = props;
		const lookupsStore = useContext(LookupContext);

		const event = useContext(EventContext);
		const team = tip?.teamId
			? lookupsStore?.teams?.get(tip.teamId)
			: undefined;
		const tournament = lookupsStore?.tournaments.get(event.tournamentId);
		const { t } = useTranslation();
		const displayTipValue = toDisplayOdd(tip.value);

		if (displayTipValue == null) {
			return null;
		}

		//#endregion  element css classes
		return (
			<div key={tip.id} className="match--outright__item quote--special">
				<div className="quote--special__tip quote quote--margin">
					<TeamIcon
						showCountryFlag={tournament?.showCountryFlag}
						flagCode={team?.countryCode}
						jerseyTypeAbrv={team?.jerseyTypeAbrv}
						className="quote--special__flag u-icon--base"
					/>
					<div className="quote--special__label">
						{tip.tip}{" "}
						{tip.gender === 1 ? (
							<React.Fragment>
								({t<string>("OFFER.GENDER.WOMEN")})
							</React.Fragment>
						) : null}
					</div>
				</div>

				<OutrightOfferRowOfferButton
					tip={tip}
					eventKey={props.eventKey}
				/>
			</div>
		);
	}
);
